'use client';

import React, { useRef } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@ui/components/ui/select';
import { useInputOptions } from '@/hooks/useInputOptions';
import { ToneOfVoice } from '@/lib/db/schema';

interface ToneOfVoiceSelectorProps {
  value: ToneOfVoice | null;
  onChange: (value?: ToneOfVoice) => void;
  className?: string;
}

export default function ToneOfVoiceSelector({ value, onChange, className = '' }: ToneOfVoiceSelectorProps) {
  const { options: toneOfVoices } = useInputOptions('toneOfVoice');
  const isUserInteraction = useRef(false);

  const handleChange = (v: string) => {
    if (isUserInteraction.current) {
      onChange((v as ToneOfVoice) || undefined);
    }
  };

  const handleOpenChange = () => {
    isUserInteraction.current = true;
  };

  return (
    <div className={className}>
      <Select value={value || ''} onValueChange={handleChange} onOpenChange={handleOpenChange}>
        <SelectTrigger className="w-full min-w-32 sm:max-w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {toneOfVoices.map((tone) => (
            <SelectItem key={tone.value} value={tone.value}>
              {tone.display}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
